import { z } from 'zod';
import { DeletedBySchema } from '../common/deleted-by.schema';
import { DealPhaseSchema, DealStatusSchema, DealTypeSchema } from './deals.schemas';

export const DeletedDealRowSchema = z.object({
  id: z.uuid(),
  workspaceId: z.uuid(),
  workspaceName: z.string().nullable(),
  organizationId: z.uuid(),
  propertyId: z.uuid(),
  propertyReference: z.string().nullable(),
  propertyDeleted: z.boolean(),
  type: DealTypeSchema,
  status: DealStatusSchema,
  phase: DealPhaseSchema,
  deletedAt: z.iso.datetime(),
  deletedBy: DeletedBySchema.nullable(),
});

export const ListDeletedDealsQuerySchema = z.object({ workspaceId: z.uuid().optional() });
export const ListDeletedDealsResponseSchema = z.object({ items: z.array(DeletedDealRowSchema) });
export const AdminDealPathParamsSchema = z.object({ id: z.uuid() });

export type DeletedDealRow = z.infer<typeof DeletedDealRowSchema>;
export type ListDeletedDealsResponse = z.infer<typeof ListDeletedDealsResponseSchema>;
